<template>
  <el-dialog :close-on-click-modal="false" title="邮寄发票" :visible.sync="isShow" width="500px">
    <el-form :model="formData" label-width="100px">
      <el-form-item label="快递公司:">顺丰速运</el-form-item>
      <el-form-item label="快递单号:">
        <el-input v-model="formData.trackNo" clearable></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { fapiaoAddExpress } from '@/api/finance.js'
export default {
  data () {
    return {
      isShow: false,
      fapiaoId: '',
      formData: {
        shipperCode: 'SF',
        trackNo: ''
      }
    }
  },
  methods: {
    show (id) {
      this.isShow = true
      this.fapiaoId = id
    },
    hide (emit) {
      this.trackNo = ''
      emit && (this.$emit('success'))
      this.isShow = false
    },
    onSubmit () {
      const reg = /^SF\d{13}$/
      const reg1 = /^[0-9]{12}$/
      console.log('reg.test(this.formData.trackNo)', reg.test(this.formData.trackNo))
      if (this.formData.trackNo === '') {
        this.$message.error('请填写快递单号')
        return
      } else if (!reg.test(this.formData.trackNo) && !reg1.test(this.formData.trackNo)) {
        this.$message.error('请输入正确快递单号')
        return
      }
      fapiaoAddExpress({
        data: this.formData,
        fapiaoId: this.fapiaoId
      })
        .then(res => {
          if (res.data.success) {
            this.$message.success('操作成功')
            this.hide(true)
          }
        })
    }

  }
}
</script>

<style>
</style>
